/// <amd-module name="Agile/Common/Redux/TeamSettings/TeamSettingsReducer" />
import { TeamSettingsAction, TeamSettingsActionTypes } from "Agile/Common/Redux/TeamSettings/TeamSettingsActions";
import { ITeamSettingsState } from "Agile/Common/Redux/TeamSettings/TeamSettingsContracts";
import { IIterationData } from "Agile/Contracts/Common";
import { default as produce } from "immer";

export function teamSettingsReducer(state: ITeamSettingsState, action: TeamSettingsAction): ITeamSettingsState {
    state = state || getDefaultState();

    return produce(state, draft => {
        switch (action.type) {
            case TeamSettingsActionTypes.TeamSettingsLoadedAction: {
                draft.teamSettings = action.payload;
            }
        }
    });
}

function getDefaultState(): ITeamSettingsState {
    return {
        teamSettings: {
            backlogIteration: getDefaultIterationData(),
            currentIteration: getDefaultIterationData(),
            futureIterations: [],
            previousIterations: [],
            teamFieldDefaultValue: "",
            teamFieldName: "",
            teamFieldValues: [],
            showBugCategoryWorkItem: false,
            bugsBehavior: 0,
            backlogVisibilities: {},
            weekends: {
                canEditWeekends: false,
                days: []
            },
            referencedNodes: {
                areaNodes: [],
                iterationNodes: []
            }
        }
    };
}

function getDefaultIterationData(): IIterationData {
    return {
        name: "",
        displayText: "",
        path: "",
        friendlyPath: "",
        id: ""
    };
}
